import { render, staticRenderFns } from "./ModalPaymentReceipt.vue?vue&type=template&id=55d85d67&scoped=true"
import script from "./ModalPaymentReceipt.vue?vue&type=script&lang=js"
export * from "./ModalPaymentReceipt.vue?vue&type=script&lang=js"
import style0 from "./ModalPaymentReceipt.vue?vue&type=style&index=0&id=55d85d67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d85d67",
  null
  
)

export default component.exports